import React from 'react';
import { Helmet } from 'react-helmet-async';

import { AdoptedTag } from './servedHead';

/**
 * Render the adopted served tags as Helmet's app-level defaults.
 *
 * A component rather than three lines inlined in `App.tsx`, and that is a
 * correction rather than tidiness. The first version of the tests rebuilt this
 * JSX by hand and never called `adoptServedHead`, so they exercised Helmet's
 * nesting rules and none of this wave's code: breaking adoption outright left
 * every one of them green. A mutation control caught it. Both the app and the
 * tests now render the same component over the output of the same function,
 * which is the only way those tests bear on the thing they are named after.
 *
 * A page that renders its own Helmet tag of the same identity REPLACES the
 * matching default rather than adding to it. That is measured in the tests
 * beside this file, not assumed from the documentation.
 */
export const ServedHeadDefaults: React.FC<{ tags: AdoptedTag[] }> = ({ tags }) => (
  <Helmet>
    {tags.map((tag) =>
      tag.property ? (
        <meta key={tag.property} property={tag.property} content={tag.content} />
      ) : (
        <meta key={tag.name} name={tag.name} content={tag.content} />
      )
    )}
  </Helmet>
);
